module.exports = __webpack_public_path__ + "static/media/Icona-10.148c1b81.svg";